import PropTypes from 'prop-types'

export const SiteSettings = PropTypes.shape({
  phone: PropTypes.string,
  email: PropTypes.string,
  facebookUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
})
